import { CommonModule } from '@angular/common'
import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { SharedUiModule } from '@galabid/shared/ui'
import { SiteAnnouncementsEntity } from 'libs/gb-dashboard/staff/data-access-site-announcements/src/lib/+state/site-announcements.models'

@Component({
  selector: 'gb-announcements-card',
  templateUrl: './gb-announcements-card.component.html',
  styleUrl: './gb-announcements-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, SharedUiModule],
})
export class GbAnnouncementsCardComponentComponent {
  @Input({ required: true }) siteAnnouncement!: SiteAnnouncementsEntity
}
